import { Routes, Route, Outlet, Navigate, useParams, useLocation } from "react-router-dom";
import { LandingPage } from "@/pages/Landing";
import { ProcessAuthCodePage } from "@/pages/ProcessAuthCode";
import { NotFoundPage } from "@/pages/NotFound";
import { RequirePermission } from "@/components/auth/RequirePermission";
import { AppLayout } from "@/components/layout/AppLayout";
import { TrainerScenarioList } from "@/pages/TrainerScenarioList";
import { TrainerNewScenario } from "@/pages/TrainerNewScenario";
import { TrainerEditScenario } from "@/pages/TrainerEditScenario";
import { LearnerSessionByProject } from "@/pages/LearnerSessionByProject";
import { LearnerScormDownload } from "@/pages/LearnerScormDownload";
import { LiveKitDebugPage } from "@/pages/LiveKitDebug";
import { AnalyticsOverviewPage } from "@/pages/analytics/AnalyticsOverview";
import { AnalyticsAvatarsPage } from "@/pages/analytics/AnalyticsAvatars";
import { AnalyticsAvatarDetailPage } from "@/pages/analytics/AnalyticsAvatarDetail";
import { AnalyticsSessionsPage } from "@/pages/analytics/AnalyticsSessions";
import { AnalyticsLayout } from "@/components/analytics/AnalyticsLayout";

function RedirectLegacyLearnProject() {
  const { projectId = "" } = useParams();
  const { search } = useLocation();
  return <Navigate to={`/learn/${projectId}${search}`} replace />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/process-authcode" element={<ProcessAuthCodePage />} />
      <Route element={<AppLayout />}>
        <Route
          path="/trainer"
          element={
            <RequirePermission permission="live-avatars.train">
              <Outlet />
            </RequirePermission>
          }
        >
          <Route index element={<TrainerScenarioList />} />
          <Route path="new" element={<TrainerNewScenario />} />
          <Route path="analytics" element={<AnalyticsLayout />}>
            <Route index element={<AnalyticsOverviewPage />} />
            <Route path="avatars" element={<AnalyticsAvatarsPage />} />
            <Route path="avatars/:avatarId" element={<AnalyticsAvatarDetailPage />} />
            <Route path="sessions" element={<AnalyticsSessionsPage />} />
          </Route>
          <Route path=":scenarioId" element={<TrainerEditScenario />} />
        </Route>
      </Route>
      <Route path="/learn/project/:projectId" element={<RedirectLegacyLearnProject />} />
      <Route path="/learn/:projectId/scorm" element={<LearnerScormDownload />} />
      <Route path="/learn/:projectId" element={<LearnerSessionByProject />} />
      <Route path="/livekit-debug" element={<LiveKitDebugPage />} />
      {/* Temporary: Kaltura client-tool feasibility probe. Remove with the probe_* actions. */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
